<template>
  <div>
    <el-form :inline="true">
      <el-form-item>
        <el-input v-model="searchForm.name" placeholder="名称" clearable>
        </el-input>
      </el-form-item>

      <el-form-item>
        <el-button @click="getRoleList">搜索</el-button>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="dialogVisible = true">新增</el-button>
      </el-form-item>
      <el-form-item>
        <el-popconfirm title="这是确定批量删除吗？" @confirm="delHandle(null)">
          <el-button type="danger" slot="reference" :disabled="delBtlStatu"
            >批量删除</el-button
          >
        </el-popconfirm>
      </el-form-item>
    </el-form>

    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      border
      stripe
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>

      <el-table-column prop="param" label="区域" width="120"> </el-table-column>
      <el-table-column prop="cityName" label="城市名" width="120">
      </el-table-column>
      <el-table-column prop="provinceName" label="省份名" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="callName" label="客服名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="icon" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="permHandle(scope.row.id)"
            >分配人员</el-button
          >
          <el-divider direction="vertical"></el-divider>
          <el-button type="text" @click="editHandle(scope.row.id)"
            >编辑</el-button
          >
          <el-divider direction="vertical"></el-divider>

          <template>
            <el-popconfirm
              title="这是一段内容确定删除吗？"
              @confirm="delHandle(scope.row.id)"
            >
              <el-button type="text" slot="reference">删除</el-button>
            </el-popconfirm>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="current"
      :page-size="size"
      :total="total"
    >
    </el-pagination>

    <!--新增对话框-->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="600px"
      :before-close="handleClose"
    >
      <el-form
        :model="editForm"
        :rules="editFormRules"
        ref="editForm"
        label-width="100px"
        class="demo-editForm"
      >
        <el-form-item label="省" prop="provinceName" label-width="100px">
          <el-select
            v-model="editForm.provinceId"
            placeholder="全部"
            ref="proLabel"
            @change="getcity(editForm.provinceId)"
          >
            <template v-for="item in province">
              <el-option
                :label="item.addName"
                :value="item.addCode"
              ></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="市" prop="cityName" label-width="100px">
          <el-select
            v-model="editForm.cityId"
            placeholder="全部"
            ref="cityLabel"
          >
            <template v-for="item in city">
              <el-option
                :label="item.addName"
                :value="item.addCode"
              ></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="区域" prop="param" label-width="100px">
          <el-input v-model="editForm.param" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('editForm')"
            >立即创建</el-button
          >
          <el-button @click="resetForm('editForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="分配权限" :visible.sync="permDialogVisible" width="800px">
        <el-form :inline="true">
      <el-form-item>
        <el-input v-model="permForm.username" placeholder="名称" clearable>
        </el-input>
      </el-form-item>

      <el-form-item>
        <el-button @click="getPeople(permForm)">搜索</el-button>
      </el-form-item>
    </el-form>
    <el-table
      ref="multipleTable"
      :data="permForm"
      tooltip-effect="dark"
      style="width: 100%"
      border
      stripe
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="头像" width="50">
        <template slot-scope="scope">
          <el-avatar size="small" :src="permForm.avatar"></el-avatar>
        </template>
      </el-table-column>
      <el-table-column prop="username" label="用户名" width="120"> </el-table-column>
      <el-table-column prop="city" label="城市" width="120">
      </el-table-column>
      <el-table-column prop="phone" label="电话" show-overflow-tooltip>
      </el-table-column>
    </el-table>
      <el-form :model="postForm">
        
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="permDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitPermFormHandle('postForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "area",
  data() {
    return {
      searchForm: {},
      delBtlStatu: true,

      total: 0,
      size: 10,
      current: 1,

      dialogVisible: false,
      editForm: {},
      userInfo: {
        id: "",
        username: "",
        avatar: "",
        roles: "",
      },
      tableData: [],
      province: [],
      city: [],
      editFormRules: {
        name: [{ required: true, message: "请输入角色名称", trigger: "blur" }],
        code: [{ required: true, message: "请输入唯一编码", trigger: "blur" }],
        statu: [{ required: true, message: "请选择状态", trigger: "blur" }],
      },

      multipleSelection: [],

      permDialogVisible: false,
      permForm: {},
      postForm:{},
      defaultProps: {
        children: "children",
        label: "name",
      },
      permTreeData: [],
    };
  },
  created() {
    this.getRoleList();
    this.getprovince();
    const userInfo = localStorage.getItem("userInfo");
    if (userInfo != null) {
      this.userInfo = JSON.parse(userInfo);
    }
  },
  methods: {
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;

      this.delBtlStatu = val.length == 0;
    },

    handleSizeChange(val) {
      this.size = val;
      this.getRoleList();
    },
    handleCurrentChange(val) {
      this.current = val;
      this.getRoleList();
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
      this.editForm = {};
    },
    handleClose() {
      this.resetForm("editForm");
    },

    getRoleList() {
      this.$axios
        .get("/gw/zone/list", {
          params: {
            name: this.searchForm.name,
            current: this.current,
            size: this.size,
          },
        })
        .then((res) => {
          this.tableData = res.data.data;
          this.size = res.data.data.size;
          this.current = res.data.data.current;
          this.total = res.data.data.total;
        });
    },
    getprovince() {
      this.$axios.get("/gw/address/child/0").then((res) => {
        if (res.status == 200) {
          this.province = res.data.data;
        }
      });
    },

    getcity(pid) {
      this.city = "";
      this.$axios.get("/gw/address/child/" + pid).then((res) => {
        if (res.status == 200) {
          this.city = res.data.data;
        }
      });
    },
    submitForm(formName) {
      if (this.editForm.id) {
        this.editForm.updateId = this.userInfo.id;
        this.editForm.updateName = this.userInfo.username;
      } else {
        this.editForm.createId = this.userInfo.id;
        this.editForm.createName = this.userInfo.username;
      }
      this.editForm.provinceName = this.$refs.proLabel.selected.label;
      this.editForm.cityName = this.$refs.cityLabel.selected.label;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
            .post(
              "/gw/zone/" + (this.editForm.id ? "update" : "save"),
              this.editForm
            )
            .then((res) => {
              //   alert(JSON.stringify(res));
              this.$message({
                showClose: true,
                message: "恭喜你，操作成功",
                type: "success",
                onClose: () => {
                  this.getRoleList();
                },
              });

              this.dialogVisible = false;
              this.resetForm(formName);
            });
        } else {
          return false;
        }
      });
    },
    editHandle(id) {
      this.$axios.get("/gw/zone/info/" + id).then((res) => {
        this.editForm = res.data.data;
        this.editForm.provinceId = String(this.editForm.provinceId);
        this.getcity(this.editForm.provinceId);
        this.editForm.cityId = String(this.editForm.cityId);
        this.dialogVisible = true;
      });
    },
    delHandle(id) {
      var ids = [];

      if (id) {
        ids.push(id);
      } else {
        this.multipleSelection.forEach((row) => {
          ids.push(row.id);
        });
      }


      this.$axios.post("/gw/zone/delete", ids).then((res) => {
        this.$message({
          showClose: true,
          message: "恭喜你，操作成功",
          type: "success",
          onClose: () => {
            this.getRoleList();
          },
        });
      });
    },
    permHandle(id) {
      this.permDialogVisible = true;
      let item = {};
      item.id = id;
       this.$axios.get("/gw/zone/info/" + id).then((res) => {
        this.editForm = res.data.data;
        this.getPeople(item);
      });

    },
    getPeople(item) {
        let url = "/gw/sys/user/listByRoleId?zoneId="+item.id+"&username="+item.username;
        if(typeof item.username == 'undefined'){
           url = "/gw/sys/user/listByRoleId?zoneId="+item.id;
        }
      this.$axios
        .get(url)
        .then((res) => {
          this.permForm = res.data.data.records;
        });
    },
    submitPermFormHandle(formName) {
   
      this.editForm.callId = this.multipleSelection[0].id;
       this.editForm.callName = this.multipleSelection[0].username;
      //  return;
      //  return;
          this.$axios
            .post(
              "/gw/zone/update",
              this.editForm
            )
            .then((res) => {
              //   alert(JSON.stringify(res));
              this.$message({
                showClose: true,
                message: "恭喜你，操作成功",
                type: "success",
                onClose: () => {
                    this.permDialogVisible = false;
                  this.getRoleList();
                },
              });

            
              this.resetForm(formName);
            });

    },
  },
};
</script>

<style scoped>
.el-pagination {
  float: right;
  margin-top: 22px;
}
</style>
